module.exports = __webpack_public_path__ + "img/jacket-back-sub-raglan-classic.d4d13b6e.png";